module.exports = __webpack_public_path__ + "img/banner1.329b9a4f.png";